import { IAlertUser, INoteCategoryModel, INoteModel } from '../../../interfaces/INote';

import { AlertTypes } from '../../../utilities/Constants';
import { IMultiSelectOption } from '../../../interfaces/ILookup';
import { IUserModel } from '../../../interfaces/IUser';
import { JSX } from 'react';
import { NoteEditorDecision } from './NoteEditorDecision';

interface INoteEditorFieldsReadOnlyProps {
    currentNote: INoteModel;
    enableNoteAssociations?: boolean;
    getAdditionalFieldsByNoteCategory: (
        noteCategory: INoteCategoryModel
    ) => JSX.Element | undefined;
    getUserFullNameDisplay: (user: IUserModel) => string;
    noteAssociationTitle?: string;
    selectedEntityItems?: IMultiSelectOption[];
}

const NoteEditorFieldsReadOnly = (props: INoteEditorFieldsReadOnlyProps) => {
    return (
        <div className="col-sm-9">
            <div className="row mb-2">
                <div className="col-sm-2">
                    <label className="text-gray">Purpose *</label>
                </div>
                <div className="col-sm-5">
                    <span>{props.currentNote.purpose?.displayName}</span>
                </div>
            </div>
            <NoteEditorDecision currentNote={props.currentNote} />
            <div className="row mb-2">
                <div className="col-sm-2">
                    <label className="text-gray">Category *</label>
                </div>
                <div className="col-sm-10">
                    {props.currentNote.categories?.map((item: INoteCategoryModel, i: number) => {
                        return (
                            <div key={i}>
                                <span>
                                    {item.displayName}
                                    {item.subCategory ? ' - ' + item.subCategory!.displayName : ''}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
            {props.currentNote.categories?.map((item: INoteCategoryModel, i: number) => {
                return <div key={i}>{props.getAdditionalFieldsByNoteCategory(item)}</div>;
            })}
            {props.enableNoteAssociations && props.selectedEntityItems && (
                <div className="row" style={{ marginBottom: '50px' }}>
                    <label className="text-gray">
                        {props.noteAssociationTitle || 'Association(s)'}
                    </label>
                    <ul>
                        {props.selectedEntityItems.map((item: IMultiSelectOption) => {
                            return <li key={item.id}>{item.label}</li>;
                        })}
                    </ul>
                </div>
            )}
            {props.currentNote.alert && (
                <div className="row mb-2">
                    <div className="col-sm-2">
                        <label className="text-gray">Action Target *</label>
                    </div>
                    <div className="col-sm-5 d-inline-block">
                        {props.currentNote.alert.users ? (
                            <ul>
                                {props.currentNote.alert
                                    .users!.filter(
                                        (x) => x.type && x.type.id === AlertTypes.Act.Value
                                    )
                                    .map((alertUser: IAlertUser, i: number) => {
                                        return (
                                            <li key={i}>
                                                {props.getUserFullNameDisplay(alertUser.user!)}
                                            </li>
                                        );
                                    })}
                            </ul>
                        ) : null}
                    </div>
                </div>
            )}
            <div>
                <div className="row mb-2">
                    <label className="text-gray">Summary</label>
                    <div style={{ whiteSpace: 'pre-wrap' }}>
                        {props.currentNote!.content
                            ? props.currentNote!.content!.replace(/\\n/gi, '\n')
                            : ''}
                    </div>
                </div>
                <div className="row mb-2">
                    <label className="text-gray">Context</label>
                    <div style={{ whiteSpace: 'pre-wrap' }}>{props.currentNote!.context}</div>
                </div>
            </div>
        </div>
    );
};

export default NoteEditorFieldsReadOnly;
